module.exports = {
    init,
    setPercentage
};

function init (id, label) {
    let progressBarElement = document.getElementById(`${id}-progress-bar`);
    if (progressBarElement) {
        document.getElementById(`${id}-progress-name`).innerHTML = label;
        document.getElementById(`${id}-progress-bar-inner`).style.width = '0%';
        document.getElementById(`${id}-progress-percentage`).innerHTML = '0%';
        progressBarElement.style.visibility = 'visible';
    }
}

function setPercentage (id, percentage) {
    let progressBarInnerElement = document.getElementById(`${id}-progress-bar-inner`);
    let progressBarPercentageElement = document.getElementById(`${id}-progress-percentage`);
    if (progressBarInnerElement && progressBarPercentageElement) {
        let percentString = Math.round(percentage).toString() + '%';
        progressBarInnerElement.style.width = percentString;
        progressBarPercentageElement.innerHTML = percentString;
    }
}



// WEBPACK FOOTER //
// ./helpers/progress-bar.js